import { defineComponent as _defineComponent } from 'vue'

import { ArticleV1 } from '@ilteducation/content-registry-types';
import ArticleQuestionForm from '../../components/article/ArticleQuestionForm.vue';
import ArticleSummaryForm from '../../components/article/ArticleSummaryForm.vue';

type Props = {
  id: string;
  title: string;
  item: ArticleV1;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Edit',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
  title: string;
  item: ArticleV1;
}



const audioFragmentFields = [
  {
    source: 'id',
    link: 'edit',
    sortable: true,
  },
  {
    source: 'key',
    sortable: true,
  },
  {
    source: 'language',
    sortable: true,
  },
];

const contentImageFields = [
  {
    source: 'id',
    link: 'edit',
    sortable: true,
  },
  {
    source: 'description',
    sortable: true,
  },
];

return { __sfc: true,props, audioFragmentFields, contentImageFields, ArticleQuestionForm, ArticleSummaryForm }
}

})